"use client";

import { ElementType, FunctionComponent } from "react";
import { Wrapper } from "./close.styles";
import { TailwindColors } from "@components/common/types/general";

export interface CloseProps {
    /**
     * Color of the close button.
     */
    color?: keyof TailwindColors | undefined;

    /**
     * A callback function which will be fired on click.
     */
    onClick?: (event: React.MouseEvent<HTMLButtonElement>) => void;

    /**
     * Size of the close button.
     */
    size?: "sm" | "lg";

    /**
     * Whether the background should be shown or not.
     */
    background?: boolean | true;

    /**
     * Define the component of the close button.
     */
    component?: ElementType;

    /**
     * Class name of the close button.
     */
    className?: string;
}

export const Close: FunctionComponent<CloseProps> = ({ color, onClick, size, background = true, component = "button", className }) => {
    return (
        <Wrapper
            type={component === "button" ? "button" : undefined}
            as={component}
            color={color}
            onClick={onClick}
            size={size}
            background={background}
            className={className}
        >
            <span>
                <span></span>
            </span>
        </Wrapper>
    );
};
